// extracted by mini-css-extract-plugin
module.exports = {"keyboard":"Keyboard_keyboard__22PLz","button":"Keyboard_button__1m6db"};